import { generalDataset } from '@mono/types/src/mds';
import { wktToGeoJson } from 'utils/wktToGeoJson';

export const sourceId = 'mov://datasource-datasets';

export const renderLayer = {
    id: sourceId,
    type: 'line',
    source: sourceId,
    interactive: true,
    paint: {
        'line-color': '#857dff',
        'line-width': 3,
    },
};

export const generateSource = (dataset: generalDataset): GeoJSON.FeatureCollection<GeoJSON.GeometryObject> => {
    return {
        type: 'FeatureCollection' as const,
        features: [
            {
                type: 'Feature' as const,
                id: dataset.id,
                properties: {
                    id: dataset.id,
                },
                geometry: wktToGeoJson(dataset.spatial_boundary) as GeoJSON.GeometryObject,
            },
        ],
    };
};
